import React from 'react';
import jet from "@randajan/jet-core";


import { Article as ArticleOrig } from "@randajan/jet-react/dom/article";
import { Tile } from "@randajan/jet-react/dom/tile";

import "./Article.scss";
import { bifrost } from '../../config/bifrost';


const _particles = {
    avatar:(alt, src)=><Tile className="avatar" caption={alt} src={src} />
}

export const Article = (props)=>{

    const fetchSrc = async src =>{
        if (props.local) { return fetch(src).then(r=>r.text()); }
        //return new Promise((res, rej)=>{setTimeout(res, 1000000)});
        const article = await bifrost.tx("sunGetArticle", src);
        return article?.content;
    };

    return <ArticleOrig {...Object.jet.exclude(props, ["local", "fetch"])} fetch={fetchSrc} particles={_particles}/>
}
